import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import { setExtrapropsWorkFlow, setSectionsReload } from '../../core/actions';
import DefaultSettings from '../../core/controls/components/settings';
import { GetData, PutData } from '../../core/modules/form/formsapi';
import { requestApi } from '../../core/modules/form/utilities';
import { getEnvVariable } from '../../modules/environmentalList';
import Typography from '@material-ui/core/Typography';
import { PostData } from '../../core/controls/helpers/requests';
const _ = require('lodash');


export default function CWorkflow(props) {
    const { fieldValues, handleFieldValue, items } = props;
    const dispatch = useDispatch();
    let currentWorkflowId = null;
    if (fieldValues) {

        if (fieldValues['SitepermittypeWorkflowId'] == 0)
            fieldValues['SitepermittypeWorkflowId'] = null;
        if (fieldValues['WorkflowId'] == 0)
            fieldValues['WorkflowId'] = null;
        if (fieldValues['WorkflowId'])
            currentWorkflowId = fieldValues['WorkflowId'];
        else if (fieldValues['editInfo'] && fieldValues['editInfo']['WorkflowId'])
            currentWorkflowId = fieldValues['editInfo']['WorkflowId'];
        // else if (items && items.length > 0)
        //     currentWorkflowId = items.find(i => i['isDefault'] === 'Y' || i['IsDefault'] === 'Y').WorkflowId
    }
    console.log('CWorkflow', fieldValues, props)
    const params = useParams();
    const extrapropsworkflow = useSelector(state => state.header
        && state.header.extrapropsworkflow
    )
    console.log('CWorkflow', extrapropsworkflow, useSelector(state => state.header))
    const [firstSet, setFirstSet] = useState({})
    const [initialLoad, setInitialLoad] = useState(false);
    const [currentFieldVals, setCurrentFieldVals] = useState({})

    useEffect(() => {
        if (fieldValues && fieldValues['Upgrade'] !== 'Y') {
            if (fieldValues && fieldValues['SitepermittypeWorkflowId'])
                setCurrentFieldVals({ ...fieldValues })
        }
    }, [fieldValues, fieldValues.SitepermittypeWorkflowId])


    useEffect(() => {
        if (extrapropsworkflow || (fieldValues && Object.keys(fieldValues).length > 0 && fieldValues['WorkflowId']))
            if ((fieldValues && fieldValues['WorkflowId'] && (fieldValues['WorkflowId'] !== firstSet['WorkflowId']))
                || fieldValues['WorkflowId'] !== currentFieldVals['WorkflowId']) {
                setInitialLoad(false);
                // setFirstSet({ ...firstSet, ...fieldValues })
            }
        if (extrapropsworkflow && extrapropsworkflow.takeIsDefault) {
            loadMasterflow(extrapropsworkflow.takeIsDefault);
            dispatch(setExtrapropsWorkFlow({ ...extrapropsworkflow, takeIsDefault: false }))
        }

        else if (extrapropsworkflow && fieldValues['SitepermittypeWorkflowId'] && currentFieldVals.SitepermittypeWorkflowId &&
            extrapropsworkflow.takeIsDefault === false &&
            currentFieldVals.SitepermittypeWorkflowId !== fieldValues['SitepermittypeWorkflowId']) {
            loadMasterflow(false)
        }
        else if (fieldValues['IsCurrent'] == "N" || fieldValues.allgriddata && fieldValues.allgriddata[0].IsCurrent == 'N') {
            fieldValues['WorkflowId'] = fieldValues.allgriddata[0].WorkflowId
            loadMasterflow(false)
        }
        else {
            setFirstSet(
                {
                    IsAdmin: currentWorkflowId ? false : props.IsAdmin,
                    WorkflowId: (currentWorkflowId) ? currentWorkflowId : (props.IsAdmin && extrapropsworkflow && extrapropsworkflow.dataItem && extrapropsworkflow.dataItem['WorkflowId']) ? extrapropsworkflow.dataItem['WorkflowId']
                        : (extrapropsworkflow && extrapropsworkflow && extrapropsworkflow.WorkflowId ? extrapropsworkflow.WorkflowId : ""),
                    ParentWorkflowId: '',
                    workflowitems: [],
                    defaultworkflow: '',
                    configType: extrapropsworkflow.configType,
                    configId: extrapropsworkflow.configId,
                    SitepermittypeWorkflowId: fieldValues.Upgrade == 'Y' ? null : (fieldValues.SitepermittypeWorkflowId || (extrapropsworkflow && extrapropsworkflow.SitepermittypeWorkflowId)),
                    IsCurrent: fieldValues.IsCurrent
                }
            )

        }
    }, [extrapropsworkflow, fieldValues, currentWorkflowId])


    useEffect(() => {
        if (firstSet && Object.keys(firstSet).length > 0 && initialLoad === false
            && ((firstSet.IsAdmin || (firstSet.SitepermittypeWorkflowId > 0 && (!firstSet.WorkflowId || firstSet.WorkflowId < 1))
                || (firstSet.SitepermittypeWorkflowId > 0 && firstSet.WorkflowId > 0)) ||
                (!firstSet.IsAdmin && !firstSet.SitepermittypeWorkflowId && (!firstSet.WorkflowId || firstSet.WorkflowId < 1)))) {
            setInitialLoad(true)
            functionInitalMount()
        }
        else
            if (currentWorkflowId && firstSet && Object.keys(firstSet).length === 0)
                functionInitalMount()
    }, [firstSet])



    const functionInitalMount = () => {
        //Load the the ID's based on the admin/application flow
        //var isAdmin = false;
        if (firstSet && Object.keys(firstSet).length > 0) {
            if (firstSet.IsAdmin) {
                loadAdminflow();
            } else {
                if (firstSet && (firstSet.SitepermittypeWorkflowId > 0 && firstSet.WorkflowId > 0)) {
                    workflowprocessMain()
                }
                else if (firstSet.SitepermittypeWorkflowId > 0 && (!firstSet.WorkflowId || firstSet.WorkflowId < 1)) {
                    loadMasterflow(true);
                }
                else if (!firstSet.SitepermittypeWorkflowId && (!firstSet.WorkflowId || firstSet.WorkflowId < 1)) {
                    loadMasterflow(false);
                }
            }
        }
        else if (currentWorkflowId && (!firstSet.SitepermittypeWorkflowId && (!firstSet.WorkflowId || firstSet.WorkflowId < 1))) {
            loadMasterflow(false);
        }
    }


    const loadAdminflow = () => {
        var sourceURL = getEnvVariable('AdminConfig') + "/api/SitePermitTypeWorkflow/" + params.routeid + `/${extrapropsworkflow.configId}/SitePermitWorkFlows`;
        // props.snackbarMessage('Please wait, Information is processing', 'info');
        DefaultSettings.getAlert('Please wait, Information is processing', 'info');
        GetData(sourceURL, "").then(results => {
            if (results && results.length > 0) {
                var firstResult = results[0];
                setFirstSet({ ...firstResult });
            }
            workflowprocessAdmin();
        }).catch(ex => {
            DefaultSettings.getAlert('Unable to process the workflow ', 'error')
        })
    }

    const loadMasterflow = (isDefault = false) => {
        const { ParentWorkflowId, WorkflowId, configId } = firstSet
        var sourceURL = getEnvVariable('AdminConfig') + "/api/SitePermitTypeWorkflow/" + params.routeid + `/${extrapropsworkflow.configId}/SitePermitWorkFlows`;
        if (params.routeid && params.routeid1) {
            // props.snackbarMessage('Please wait, Information is processing', 'info');
            DefaultSettings.getAlert('Please wait, Information is processing', 'info');
            GetData(sourceURL, "").then(results => {
                if (results && results.length > 0) {
                    let defaultworkflowval = null
                    let defaultworkflowitem = _.find(results, { IsDefault: 'Y' })
                    defaultworkflowval = defaultworkflowitem ? defaultworkflowitem.WorkflowId : null
                    if (defaultworkflowval && isDefault) {
                        let loadworkflow = WorkflowId === "" ? _.find(results, { IsDefault: 'Y' }) :
                            ParentWorkflowId !== 0 ? _.find(results, { "WorkflowId": Number(ParentWorkflowId) }) : null
                        var tempfirstResult = loadworkflow ? loadworkflow : (defaultworkflowitem || results[0]);
                        setFirstSet({
                            ...tempfirstResult, ParentWorkflowId: WorkflowId ? WorkflowId : tempfirstResult.WorkflowId,
                            workflowitems: results, workflowval: loadworkflow ? tempfirstResult.WorkflowId : "", disableddropdown: WorkflowId ?
                                true : false, resetbutton: WorkflowId ? true : false, defaultworkflow: defaultworkflowval
                        })
                        let defaultSet = {
                            ...tempfirstResult, ParentWorkflowId: WorkflowId ? WorkflowId : tempfirstResult.WorkflowId,
                            workflowitems: results, workflowval: loadworkflow ? tempfirstResult.WorkflowId : "", disableddropdown: WorkflowId ?
                                true : false, resetbutton: WorkflowId ? true : false, defaultworkflow: defaultworkflowval
                        }
                        workflowprocessMain(defaultSet);
                    }
                    else {
                        let currentset = _.find(results, { Id: fieldValues['SitepermittypeWorkflowId'] > 0 ? fieldValues['SitepermittypeWorkflowId'] : null })
                        let defaultSet = {
                            ...currentset, ParentWorkflowId: currentset.WorkflowId,
                            workflowitems: results, workflowval: currentset.WorkflowId || "", defaultworkflow: null
                        }
                        setFirstSet({ ...defaultSet })
                        workflowprocessMain(defaultSet);
                    }
                } else {
                    /* Loading workflow without default workflow */
                    let sitepermittypeWorkflowId = fieldValues['SitepermittypeWorkflowId'] || 0
                    //if (fieldValues['SitepermittypeWorkflowId']) {
                    setFirstSet({
                        ...firstSet, ...fieldValues, "ParentWorkflowId": 0, workflowval: "", workflowitems: results,
                        disableddropdown: false, resetbutton: false, defaultworkflow: null
                    })
                    let defaultSet = {
                        ...firstSet, ...fieldValues, "ParentWorkflowId": sitepermittypeWorkflowId, workflowval: "", workflowitems: results,
                        defaultworkflow: null
                    }

                    workflowprocessMain(defaultSet);
                }


            }).catch(ex => {
                //DefaultSettings.getAlert().show('Unable to process the workflow ', 'error')
            })
        } else DefaultSettings.getAlert('Unable to process the workflow ', 'error')
    }


    const workflowprocessAdmin = () => {
        var isAdd = (firstSet.WorkflowId) <= 0;
        let RoleRegionsurl = `/InternalAccessControlView/GetUserRoleConfigTypeForWorkflowActiveUsers/` + getEnvVariable('ModuleKey') + `/${firstSet.configType}/?isAdmin=${props.IsAdmin}&configIds=${firstSet.configId}`;
        if (typeof window.workflowObj !== "undefined") {
            //For administration save
            if (isAdd) {
                //  inprops.snackbarMessage('Please wait, Information is processing', 'info');
                window.workflowObj.render({
                    isAdmin: props.IsAdmin,
                    el: "#play", userdata: RoleRegionsurl, success: function (e) {
                        console.log(e);
                        if (e.id) {
                            let resultdata = {
                                isDefault: 'N',
                            }
                            var sourceURL = getEnvVariable('AdminConfig') + "/api/SitePermitTypeWorkflow/" + firstSet.SitePermitTypeAppSettingsId + "/" + e.id + "/add";
                            let finalurl = { url: sourceURL }
                            let url = { post: finalurl }
                            requestApi(url, [], resultdata).then(response => {
                                //inprops.snackbarMessage('Workflow Saved Successfully', 'success')
                                // if (ApplicationID) { }
                                //inprops.setSectionsReload(true) //window.location.reload();
                                //  else inprops.onClose();
                            }).catch(ex => {
                                //  inprops.snackbarMessage('Unable to process the workflow ', 'error')
                            })

                        }
                    }
                });
            } else {
                //  inprops.snackbarMessage('Please wait, Information is processing', 'info');
                window.workflowObj.render({
                    isAdmin: props.IsAdmin,
                    id: firstSet.WorkflowId,
                    el: "#play", userdata: RoleRegionsurl, success: function (e) {
                        console.log(e);
                        DefaultSettings.getAlert().show('Workflow Updated Successfully', 'success')
                    }
                });
            }

        }
    }


    const workflowprocessMain = (defaultSet = null) => {
        var isAdd = (defaultSet && defaultSet.WorkflowId && defaultSet.IsDefault !== 'Y') ? false : (firstSet.WorkflowId === undefined) || (firstSet.WorkflowId === null) || (firstSet.WorkflowId <= 0);
        let RoleRegionsurl = `/InternalAccessControlView/GetUserRoleConfigTypeForWorkflowActiveUsers/` + getEnvVariable('ModuleKey') + `/${extrapropsworkflow.configType}/?isAdmin=${props.IsAdmin ? true : false}&configIds=${extrapropsworkflow.configId} `;
        if (typeof window.workflowObj !== "undefined") {
            //When loading from the application/permit will have parentid
            if (isAdd) {
                DefaultSettings.getAlert('Please wait, Information is processing', 'info');
                window.workflowObj.render({
                    parentid: defaultSet ? defaultSet.ParentWorkflowId : firstSet.ParentWorkflowId,
                    isAdmin: props.IsAdmin,
                    el: "#play", userdata: RoleRegionsurl, success: function (e) {


                        var parentworkflowidval = defaultSet ? defaultSet.ParentWorkflowId : (firstSet.ParentWorkflowId !== "" ? firstSet.ParentWorkflowId : 0)
                        let workflowid = e.id ? e.id : firstSet.WorkflowId;
                        setFirstSet({ ...firstSet, ...e })
                        handleFieldValue({ target: { value: workflowid, name: "WorkflowId" } })
                        //handleFieldValue({ target: { WorkflowId: workflowid }})
                        var applicationUpdateUrl = getEnvVariable('Application') + "/api/Application/UpdateWorkflow/" + `${params.routeid}` + "/" + `${params.routeid1}` + "?&status=&workflowid=" + workflowid + "&parentworkflowid=" + parentworkflowidval;
                        // //  insetState({ WorkflowId: e.id ? e.id : firstSet.WorkflowId, reloadWorkflowId: e.id ? e.id : firstSet.WorkflowId }, () => {
                        PutData(applicationUpdateUrl, null).then(function (res) {

                            if (res && workflowid && props.fieldValues && params) {
                                let workflowsaveurl = props.fieldProps.save.url.read[0]
                                let url = props.fieldProps.save.url.read[0].url
                                let id
                                workflowsaveurl.matchProps.forEach(each => {
                                    const { key } = each
                                    id = workflowsaveurl.matchProps ? params[key] : null
                                    url = `${url.replace(`{${key}}`, id)}`

                                })
                                let bodyobj = props.fieldValues
                                bodyobj.WorkflowId = workflowid
                                PostData(url, bodyobj).then(result => {
                                    if (result) {
                                        props.handleBack(true)
                                        //SidePopUp(false)
                                        // navigator(window.location.href)

                                    }
                                })
                            }


                            window.workflowObj.data.submit(workflowid, function () {
                                //DefaultSettings.getAlert().show('Please click on the save button to save the workflow.', 'info')
                                //         //  inprops.handlereload(instate.reloadWorkflowId)
                                //         // inprops.snackbarMessage('Workflow Saved Successfully', 'success');
                                //         //window.location.reload();
                                dispatch(setSectionsReload(true));
                            }, function () {
                                //DefaultSettings.getAlert().show('Unable to process the workflow ', 'error')
                                // inprops.snackbarMessage('Unable to process the workflow ', 'error')
                            });
                        });
                        // })
                    }
                });
            }

            else {
                //DefaultSettings.getAlert().show('Please wait, Information is processing', 'info');
                // inprops.snackbarMessage('Please wait, Information is processing', 'info');
                window.workflowObj.render({
                    isAdmin: props.IsAdmin || false,
                    id: defaultSet ? defaultSet.WorkflowId : firstSet.WorkflowId,
                    parentid: defaultSet ? defaultSet.ParentWorkflowId : firstSet.ParentWorkflowId,
                    el: "#play", userdata: RoleRegionsurl, success: function (e) {
                        //window.workflowObj.data.submit(e.id, function () {
                        DefaultSettings.getAlert().show('Workflow Saved Successfully', 'success');
                        //DefaultSettings.getAlert().show('Please click on the save button to save the workflow.', 'info')
                        setSectionsReload(true)
                        props.handleBack(true)
                        //window.location.reload();
                        //}, function () { inprops.snackbarMessage('Unable to process the workflow ', 'error'); }
                        // )
                    }
                });
            }
        }
    }


    return (
        <>
            {firstSet && Object.keys(firstSet).length > 0 && <Typography variant={'body2'}
                className="fw-bold" >Is Current  :  {firstSet.isComplete ? "No" : "Yes"}</Typography>}
            <div className="sketch_ToolBox_Widget" >
                <div id="play" className="workflow-wrapper">                    </div>
            </div>
        </>
    )

}